import { __rest } from "tslib";
import { node } from 'prop-types';
import React, { createContext, useCallback, useContext, useState, useMemo } from 'react';
const FIELD_REGISTRY_CONTEXT = createContext();
export function useFieldRegistry() {
    return useContext(FIELD_REGISTRY_CONTEXT);
}
export default function FieldRegistry(props) {
    const { children } = props, otherProps = __rest(props, ["children"]);
    const [registry, setRegistry] = useState({});
    const registerField = useCallback((field) => {
        setRegistry((old) => (Object.assign(Object.assign({}, old), { [field.name]: field })));
    }, []);
    const deregisterField = useCallback((fieldName) => {
        setRegistry((old) => (Object.assign(Object.assign({}, old), { [fieldName]: undefined })));
    }, []);
    const getFieldLabel = useCallback((fieldName) => {
        const field = registry[fieldName];
        if (field) {
            return field.label;
        }
        console.warn(`Unable to get label for non-existing field ${fieldName}`);
        return fieldName;
    }, [registry]);
    const contextValue = useMemo(() => (Object.assign({ registerField,
        deregisterField,
        registry,
        getFieldLabel }, otherProps)), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        registerField,
        deregisterField,
        registry,
        getFieldLabel,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.values(otherProps),
    ]);
    return React.createElement(FIELD_REGISTRY_CONTEXT.Provider, { value: contextValue }, children);
}
FieldRegistry.propTypes = {
    children: node,
};
//# sourceMappingURL=FieldRegistry.js.map